<template>
  <div class="content">
    <div class="main">
      <div class="infolan">
        <ul>
          <li>
            <i class="iconfont icon-pinpai"></i>品牌大厂
          </li>
          <li>
            <i class="iconfont icon-iconfontzhizuobiaozhun023138"></i>品质保证
          </li>
          <li>
            <i class="iconfont icon-gouwuchekong"></i>一站采购
          </li>
          <li>
            <i class="iconfont icon-taocanxinxi"></i>套餐组合
          </li>
          <li>
            <i class="iconfont icon-iconzhengpin"></i>价优质保
          </li>
        </ul>
      </div>
      <div class="ttop" style="width:100%;height:492px;background:#f2f2f2"> 
      <div class="Science-select">
        <!-- <div class="Science-title" style="background:#EFEEEA">大类</div> @mouseenter="addClass(index,item)"-->
        <div class="Largeclass">
          <div class="largeclass-title">商品分类</div>
          <div
            class="dalie"
            v-for="(item,index) in title"
            :key="index"
            :label="item.matgroupid"
            @mouseenter="addClass(index,item)"
            @mouseleave="leave()"
          >{{item.matgroupname}}</div>
        </div>
        
        <div class="classification" v-if="selecrshow" @mouseenter='mouses()'  @mouseleave="leave()">
          <div class="classification-main">
            <div class="classific-title">分类</div>
            <el-radio
              @change="changeproud(item,index)"
              v-for="(item,index) in screening"
              :key="index"
              :label="item.matgroupid"
              v-model="radio"
            >{{item.matgroupname}}</el-radio>
          </div>
          <div class="classification-main">
            <div class="classific-title">品牌</div>
            <el-radio
              @change="changebar(item,index)"
              v-for="(item,index) in brand"
              :key="index"
              :label="item.brand"
              v-model="radio2"
            ></el-radio>
          </div>
        </div>
      </div>
      </div>
      <div class="searchs">
        <div>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item >{{breadcrumbname}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{breadcrumbname2}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{brandname}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div style="float:right;">
          <el-input placeholder="请输入内容" v-model="search" clearable></el-input>
          <el-button @click="ciksearch">搜索</el-button>
        </div>
      </div>
      <div class="product-main">
        <ul>
          <li v-for="(item,index) in mainlist" :key="index" @click="tosetmeal(item)">
            <div class="bran-father">
              <img :src="item.matimagemax" oncontextmenu="return false;">
              <div class="brand">桔家云</div>
            </div>
            <div class="liname">
              <div class="Model">{{item.matname}}</div>
              <div class="brands">[{{item.brand}}] {{item.matpricelevel}}</div>
              <span style="font-size: 14px;">{{item.matspecil}} {{item.matid}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <el-pagination
        :page-size="20"
        background
        :current-page.sync="page"
        @current-change="handlecurrentchange"
        layout="total, prev, pager, next, jumper"
        :total="fenye.totalCount"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      nub: "2",
      title: [],
      current: 0,
      checkList: ["全部"],
      checkList2: [],
      checkList3: [],
      showquote: false,
      search: "",
      style: [],
      brand: [],
      screening: [],
      datas: "",
      resobj: "",
      page: 1,
      matbigid: 3,
      mainlist: [],
      checked: "",
      // moreshow: true,
      radio: "全部",
      radio2: "全部",
      radio3: "全部",
      radio4: 3,
      fenye: "",
      selecrshow:false,
      breadcrumbname : '主材类',
      breadcrumbname2:'地砖',
      brandname:'全部'
    };
  },
  methods: {
    handlecurrentchange(size) {
      this.page = size;
      this.postcs();
    },
    addClass2() {
      this.brand = [];
      if (this.current == 0) {
        this.screening = this.datas.data.matgroup[3].itemdata;
        console.log("pingmu", this.screening);
        // this.screening.map((vl, vn) => {
        //   this.screening.push(vl.matgroupname)
        // });
        // let screeninglength = this.screening.length - 1;
        // this.More = this.screening.slice(12, screeninglength);
        // let res = this.screening.slice(0, 11);
        // this.screening = res;
        // console.log("kk", res);
      } else {
        this.screening = this.datas.data.matgroup[1].itemdata;
        this.screening.map((vl, vn) => {
          this.$set(vl, "checkboxs", false);
        });
      }
    },
    mouses(){
      this.selecrshow = true
    },
    leave(){
      this.selecrshow = false
      this.brand = []
    },
    addClass(index, item) {
      this.selecrshow = true;
      this.breadcrumbname = item.matgroupname
      this.screening.shift();
      this.screening = [];
      this.screening = item.itemdata;
      this.screening.unshift({
        itemdata: [],
        matbigid: "全部",
        matgroupname: "全部"
      });
      // this.moreshow = false
      this.matgroupname = "";
      this.brandname = "";
      this.matbigid = item.matgroupid;
      // this.page = 1;
      // this.postcs();
      console.log("11", this.screening);
    },
    getproduct: async function() {
      let data = {
        page: this.page,
        limit: 20,
        matbigid: this.matbigid
      };
      let res = await this.exequy.getproduct(data);
      this.datas = res.data;
      this.title = this.datas.data.matgroup;
      //console.log("res", res);
      this.style = res.data.data.style;
      this.style.unshift({ style: "全部", id: "全部" });
      this.all = res.data.data.matgroup[3].itemdata;
      this.addClass2();
      this.all.unshift({
        itemdata: [],
        matbigid: "全部",
        matgroupname: "全部"
      });
      console.log("aaa", this.all);
    },
    changeproud(item, index) {
      console.log("index", item);
      this.breadcrumbname2 = item.matgroupname
      this.brand.shift();
      this.brand = item.itemdata;
      this.brand.unshift({ brand: "全部" });
      this.brandname = "全部";
      this.matgroupname = item.matgroupid;
      this.page = 1;
      this.postcs();
      console.log("www", this.brand);
    },
    changebar(item) {
      this.brandname = item.brand;
      //console.log("checkList3", item);
      this.page = 1;
      this.postcs();
    },
    postcs: async function() {
      let data = {
        page: this.page,
        searchvalue: this.search,
        limit: 20,
        matbigid: this.matbigid,
        matgroupid: this.matgroupname,
        brand: this.brandname
        // style: this.stylesp
      };
      let res = await this.exequy.postfilterselect(data);
      this.fenye = res.data.page;
      //console.log("xxh", res.data);
      this.mainlist = res.data.page.list;
      //console.log("this.mainlist", this.mainlist);
    },
    ciksearch: async function() {
       let data = {
        matbigid: this.matbigid,
        searchvalue: this.search,
        page: this.page,
        limit: 20
      };
      let res = await this.exequy.postfilterselect(data);
      this.fenye = res.data.page;
      //console.log("this.fenye", this.fenye);
      this.mainlist = res.data.page.list;
      //console.log("res", this.mainlist);
    },
    styles(item) {
      this.stylesp = item.id;
      this.page = 1;
      this.postcs();
    },
    tosetmeal(item) {
      this.$router.push({
        name: "BackProductDetails",
        query: { resl: item.matid }
      });
    }
  },
  created: async function() {
    let self = this;
    self.getproduct();
    self.postcs();
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
.head {
 width: 99.15%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
}
.banane {
  width: 100%;
  height: 441px;
  
}
.banane img {
  width: 100%;
  height: 100%;
}
.classred {
  color: #fff;
  background: #b31d25;
}
.Science-select {
  width: 100%;
  position: absolute;
  top: 85px;
}
.Science-title {
  width: 8%;
  height: 3rem;
  line-height: 3rem;
  float: left;
  text-align: center;
  background: #f3f3f3;
}
.largeclass-title{
  background: #232121;
  color: #fff;
  width: 161px;
}
.classification-main {
  text-align: left;
  padding-top: 15px;
}
.classific-title {
  width: 50px;
  margin-left: 8px;
  font-size: 16px;
  font-weight: bold;
  height: 26px;
}
.Largeclass {
  float: left;
  width: 161px;
}
.dalie {
  width: 160px;
  border-bottom: 1px solid;
  text-align: center;
  height: 40.3px;
  line-height: 40.3px;
  background: #b42826;
  color: #fff;
  font-size: 18px;
}
.dalie:hover{
  background: #e77f84;
}
.classification {
  float: left;
  width: 600px;
  height: 435.97px;
  background: #fff;
}
.Science-btn {
  width: 100%;
  height: 3rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.Science-btn ul {
  overflow: hidden;
  padding-inline-start: 0px;
}
.Science-btn ul li {
  list-style: none;
  width: 80px;
  height: 33px;
  float: left;
  line-height: 33px;
  border-radius: 8px;
}
.bran-father {
  position: relative;
}
.brand {
  width: 85px;
  height: 40px;
  background: #b31d25;
  position: absolute;
  top: 0px;
  right: 0px;
  color: #fff;
  line-height: 40px;
  font-size: 19px;
}
.product-main {
  width: 100%;
}
.product-main ul {
  overflow: hidden;
  padding-inline-start: 0px;
  margin-left: -1%;
}
.product-main ul li {
  list-style: none;
  width: 24%;
  height: 435px;
  float: left;
  margin-left: 1%;
  margin-top: 1.5rem;
  border: 1px solid #ddd;
  box-sizing: border-box;
  padding: 15px;
  border-radius: 7px;
  cursor: pointer;
}
.liname {
  font-size: 15px;
  text-align: left;
  color: #827c7c;
}
.product-main ul li img {
  width: 100%;
}
.el-button--default {
  width: 100%;
  background: #b31d25;
  border: 0px;
  color: #fff;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.searchs {
  margin-top: 10px;
  margin-bottom: 1rem;
  width: 100%;
  overflow: hidden;
}
.pinas {
  width: 100%;
  float: left;
  text-align: left;
  line-height: 24px;
}
.More {
  color: #409eff;
  margin-left: 20px;
}
/* .el-radio {
  width: 40px;
} */
.classification >>> .el-radio__inner {
  display: none;
}
/* .Science-btn>>>.el-radio__label{
padding-left: 0px;
} */
.pinas >>> .el-radio__input.is-checked + .el-radio__label {
  color: #b31d25;
}
.el-pagination {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.el-button--default {
  width: 80px;
}
.el-input--suffix {
  width: 300px;
}
.infolan ul {
  color: rgb(179, 29, 37);
  margin-block-start: 0px;
  margin-block-end: 0px;
  overflow: hidden;
  background: rgb(221, 221, 221);
}
.infolan ul li {
  width: 20%;
  height: 3rem;
  line-height: 3rem;
  float: left;
  font-size: 20px;
  list-style: none;
}
.infolan ul li i {
  padding-right: 8px;
}
.Model {
  font-size: 20px;
  color: #000;
}
.brands {
  color: #c42d28;
  padding-top: 2px;
  padding-bottom: 6px;
}
</style>
